import { useEffect, useState, useCallback } from 'react';
import { motion, useSpring } from 'framer-motion';

export default function CustomCursor() {
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  const dotX = useSpring(0, { stiffness: 800, damping: 35 });
  const dotY = useSpring(0, { stiffness: 800, damping: 35 });
  const ringX = useSpring(0, { stiffness: 300, damping: 28 });
  const ringY = useSpring(0, { stiffness: 300, damping: 28 });

  const handleMouseMove = useCallback((e) => {
    dotX.set(e.clientX);
    dotY.set(e.clientY);
    ringX.set(e.clientX);
    ringY.set(e.clientY);
    if (!visible) setVisible(true);
  }, [dotX, dotY, ringX, ringY, visible]);

  useEffect(() => {
    if (window.matchMedia('(hover: none)').matches) {
      setIsTouchDevice(true);
      return;
    }

    const handleOver = (e) => {
      if (e.target.closest('a, button, [role="button"], input, textarea, select')) setHovered(true);
    };
    const handleOut = (e) => {
      if (e.target.closest('a, button, [role="button"], input, textarea, select')) setHovered(false);
    };

    window.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseover', handleOver);
    document.addEventListener('mouseout', handleOut);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseover', handleOver);
      document.removeEventListener('mouseout', handleOut);
    };
  }, [handleMouseMove]);

  if (isTouchDevice) return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-[10000]">
      <motion.div
        className="absolute w-2 h-2 bg-cream rounded-full"
        style={{ left: dotX, top: dotY, x: '-50%', y: '-50%', opacity: visible ? 1 : 0 }}
      />
      <motion.div
        className="absolute rounded-full border border-gold/70"
        style={{ left: ringX, top: ringY, x: '-50%', y: '-50%', opacity: visible ? 0.8 : 0 }}
        animate={{
          width: hovered ? 56 : 32,
          height: hovered ? 56 : 32,
          backgroundColor: hovered ? 'rgba(245,241,234,0.08)' : 'transparent',
        }}
        transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      />
    </div>
  );
}
